function Comment() {
}

Comment.fn = {
    init: function () {
        Comment.fn.generateForm.call(this);
        Comment.fn.comment.call(this);
        Comment.fn.cancelComment.call(this);
        Comment.fn.likeComment.call(this);
        Comment.fn.searchComment.call(this);
    },

    generateForm: function () {
        var template = $("#tmpl-reply-devvn-cmt");

        $("body").on("click", ".devvn_cmt_reply", function () {
            $(".devvn_cmt_list_box #devvn_cmt_reply").remove();
            var parent = $(this).closest("li"),
                parent_id = $(this).attr("data-parent"),
                author = "@" + $(this).attr("data-authorname") + ": ";

            // Replace data
            template.find('[name="content"]').text(author);
            template.find('[name="parent_id"]').val(parent_id);

            $(".devvn_cmt_child", parent).length > 0
                ? $(".devvn_cmt_child li:nth-child(1)", parent).prepend(template.html())
                : parent.append(template.html());
        });
    },

    comment: function () {
        $(document).on('submit', '#devvn_cmt, #devvn_cmt_reply', function (event) {
            event.preventDefault();
            $('body').loading('toggle');

            var elem = $(this);
            if (elem.hasClass('disabled'))
                return false;

            toastr.options.closeButton = true;
            toastr.options.positionClass = 'toast-top-right';

            $.ajax({
                url: elem.attr('action'),
                type: "post",
                dataType: "json",
                data: elem.serialize(),
                beforeSend: function () {
                    elem.addClass('disabled');
                    elem.find('#devvn_cmt_submit').attr('disabled', 'disabled');
                    elem.find('#devvn_cmt_submit').hide();
                },
                success: function (response) {
                    if (response.success == true) {
                        toastr.success(response.message);
                        $(".devvn_cmt_list_box #devvn_cmt_reply").remove();
                        elem[0].reset();
                    }

                    elem.removeClass('disabled');
                    elem.find('#devvn_cmt_submit').removeAttr('disabled');
                    elem.find('#devvn_cmt_submit').show();

                    $('body').loading('toggle');
                },
                error: function (response) {
                    var message = response.responseJSON.errors;

                    $.each(message, function (index, value) {
                        toastr.error(value);
                    });

                    elem.removeClass('disabled');
                    elem.find('#devvn_cmt_submit').removeAttr('disabled');
                    elem.find('#devvn_cmt_submit').show();

                    $('body').loading('toggle');
                }
            });

            return false;
        });
    },

    cancelComment: function () {
        $("body").on("click", ".devvn_cancel_cmt", function () {
            $(this).closest("#devvn_cmt_reply").remove();
        });
    },

    likeComment: function () {
        var flag = false;
        $("body").on("click", ".cmtlike", function (e) {
            if (e.preventDefault(), !flag && !$(this).hasClass("liked")) {
                $('body').loading('toggle');

                var id = parseInt($(this).data("id")),
                    countLike = parseInt($(this).data("like")) || 0,
                    countComment = $(".cmt_count", this);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: $(this).data('route'),
                    data: {
                        id: id
                    },
                    context: this,
                    beforeSend: function () {
                        flag = true, countComment.html(countLike + 1);
                    },
                    success: function (data) {
                        data.success ? $(this).addClass("liked") : countComment.html(countLike), flag = false;

                        $('body').loading('toggle');
                    },
                    error: function (e, t, n) {
                        flag = false, countComment.html(countLike);

                        $('body').loading('toggle');
                    }
                });
            }
        });
    },

    searchComment: function () {
        function search() {
            // Add small delay to make the keyup element smoother
            var keyUpTimer = null;
            $('#devvn_cmt_search').on('keyup', function () {
                if (keyUpTimer) {
                    clearTimeout(keyUpTimer);
                }

                var element = this;

                keyUpTimer = setTimeout(function () {
                    findComment(element);
                }, 300);
            });
        }

        function findComment(element) {
            var value = $(element).val().toLowerCase();

            $(".devvn_cmt_list_box.comment ul li").filter(function (e) {
                $(this).toggle($(this).find('.devvn_cmt_box_content p').text().toLowerCase().indexOf(value) > -1);
            });
        }

        search();
    },

    rule: function () {
        $(document).ready(function () {
            Comment.fn.init.call(this);
        });
    },
};

Comment.fn.rule();
